export const ORGANIZATION_ID_COOKIE = "organizationId";
export const ALPINEIQ = "AlpineIQ";

export const HOME = "home";
export const WHOLESALE = "wholesale";
export const RETAIL = "retail";
export const RETAIL_PROCUREMENT = "procurement";
export const RETAIL_VENDORS = "vendors";
export const RETAIL_EMPLOYEES = "employees";
export const RETAIL_REPORTS = "reports";
export const RETAIL_PROMOTIONS = "promotions";
export const RETAIL_RISK = "risk";

export const CULTIVATION = "cultivation";
export const MANUFACTURING = "manufacturing";

// Advanced Analytics Dashboard Routes
export const ROUTES_ANALYTICS = "/analytics/organizations/:id/";
export const ROUTES_ANALYTICS_DETAIL_WHOLESALE= `/analytics/organizations/:id/${WHOLESALE}`;
export const ROUTES_ANALYTICS_DETAIL_RETAIL= `/analytics/organizations/:id/${RETAIL}`;
export const ROUTES_ANALYTICS_DETAIL_RETAIL_ALPINEIQ= `/analytics/organizations/:id/${ALPINEIQ}`;
export const ROUTES_ANALYTICS_DETAIL_RETAIL_PROCUREMENT= `/analytics/organizations/:id/${RETAIL_PROCUREMENT}`;
export const ROUTES_ANALYTICS_DETAIL_RETAIL_VENDORS= `/analytics/organizations/:id/${RETAIL_VENDORS}`;
export const ROUTES_ANALYTICS_DETAIL_RETAIL_EMPLOYEES= `/analytics/organizations/:id/${RETAIL_EMPLOYEES}`;
export const ROUTES_ANALYTICS_DETAIL_RETAIL_COST_AND_MARGIN= `/analytics/organizations/:id/${RETAIL_REPORTS}`;
export const ROUTES_ANALYTICS_DETAIL_RETAIL_PROMOTIONS= `/analytics/organizations/:id/${RETAIL_PROMOTIONS}`;
export const ROUTES_ANALYTICS_DETAIL_RETAIL_RISK= `/analytics/organizations/:id/${RETAIL_RISK}`;
export const ROUTES_ANALYTICS_DETAIL_MANUFACTURING = `/analytics/organizations/:id/${MANUFACTURING}`;
export const ROUTES_ANALYTICS_DETAIL_CULTIVATION = `/analytics/organizations/:id/${CULTIVATION}`;
export const ROUTES_ANALYTICS_PRODUCT_DETAIL = "/analytics/organizations/:organizationId/integration/:integration/product/:productId";

export const TABS = {
    null: 5,
    undefined: 5,
    [WHOLESALE]: 1,
    [RETAIL]: 2,
    [CULTIVATION]: 3,
    [MANUFACTURING]: 4,
    [HOME]: 5
};

export const RETAIL_TABS = {
    null:  5,
    undefined: 5,
    [ALPINEIQ]: 1,
    [RETAIL_PROCUREMENT]: 2,
    [RETAIL_VENDORS]: 3,
    [RETAIL_EMPLOYEES]: 4,
    [RETAIL_REPORTS]: 5,
    [RETAIL_PROMOTIONS]: 6,
    [RETAIL_RISK]: 7,
};

export const RETAIL_ROUTES = {
    1: ROUTES_ANALYTICS_DETAIL_RETAIL_ALPINEIQ,
    2: ROUTES_ANALYTICS_DETAIL_RETAIL_PROCUREMENT,
    3: ROUTES_ANALYTICS_DETAIL_RETAIL_VENDORS,
    4: ROUTES_ANALYTICS_DETAIL_RETAIL_EMPLOYEES,
    5: ROUTES_ANALYTICS_DETAIL_RETAIL_COST_AND_MARGIN,
    6: ROUTES_ANALYTICS_DETAIL_RETAIL_PROMOTIONS,
    7: ROUTES_ANALYTICS_DETAIL_RETAIL_RISK,
};

export const ROUTES = {
    0: ROUTES_ANALYTICS,
    1: ROUTES_ANALYTICS_DETAIL_WHOLESALE,
    2: ROUTES_ANALYTICS_DETAIL_RETAIL,
    3: ROUTES_ANALYTICS_DETAIL_CULTIVATION,
    4: ROUTES_ANALYTICS_DETAIL_MANUFACTURING,
    5: ROUTES_ANALYTICS_DETAIL_RETAIL_PROCUREMENT,
};

export const GROUP_BY = "group by";
export const FILTER_BY = "filter by";
export const FULL_SCREEN = "full screen";
